import React, { useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { setToken, setUser } from "../utils/auth";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CONFIG from "../config";
import BRANDING from "../branding";
import SEO from "../components/common/SEO";


const Login = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language?.startsWith('ar');
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setMessage(t('auth.logging_in'));
    try {
      const res = await axios.post(`${CONFIG.API_URL}/api/auth/login`, formData, { withCredentials: true });
      setToken(res.data.token);
      if (res.data.user) setUser(res.data.user);

      setMessage(`✅ ${t('auth.success_login')}`);
      navigate("/shop");
    } catch (error) {
      setMessage(error.response?.data?.message || t('auth.failed_login'));
    }
  };

  return (
    <>
      <Helmet>
        <html lang={isArabic ? "ar" : "en"} dir={isArabic ? "rtl" : "ltr"} />
        <title>
          {isArabic
            ? `تسجيل الدخول | ${BRANDING.appName.ar}`
            : `Login | ${BRANDING.appName.en}`}
        </title>
      </Helmet>
      <SEO />

      <div
        className="max-w-md mx-auto mt-16 p-10"
        style={{ backgroundColor: 'var(--bg-header)', borderRadius: 'var(--card-radius)', border: '1px solid var(--border)', boxShadow: 'var(--card-shadow)' }}
      >
        <h2 className="text-3xl font-black mb-8 text-center" style={{ color: 'var(--text-header)' }}>{t('auth.login')}</h2>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4" style={{ color: 'var(--text-color-light)' }}>{t('auth.username')}</label>
            <input
              type="text"
              name="email"
              placeholder={t('auth.username_placeholder', 'Username or Email')}
              className="w-full p-4 border-none transition-all outline-none"
              style={{ backgroundColor: 'var(--bg-body)', borderRadius: 'var(--input-radius)', border: '1px solid var(--border)' }}
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="space-y-2">
            <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-4" style={{ color: 'var(--text-color-light)' }}>{t('auth.password')}</label>
            <input
              type="password"
              name="password"
              placeholder={t('auth.password_placeholder', '••••••••')}
              className="w-full p-4 border-none transition-all outline-none"
              style={{ backgroundColor: 'var(--bg-body)', borderRadius: 'var(--input-radius)', border: '1px solid var(--border)' }}
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          <button
            type="submit"
            style={{ backgroundColor: BRANDING.colors.primary }}
            className="w-full text-white py-5 rounded-2xl font-black uppercase tracking-widest hover:brightness-110 active:scale-95 transition-all shadow-xl shadow-brand-primary/20"
          >
            {t('auth.login')}
          </button>

          <div className="flex flex-col sm:flex-row items-center justify-between mt-6 text-sm font-medium pt-4 border-t border-gray-100 dark:border-gray-800">
            <Link to="/forgot-password" style={{ color: 'var(--text-color-light)' }} className="hover:text-brand-primary transition-colors hover:underline mb-2 sm:mb-0">
              {t('auth.forgot_password', 'Forgot Password?')}
            </Link>
            <Link to="/forgot-email" style={{ color: 'var(--text-color-light)' }} className="hover:text-brand-primary transition-colors hover:underline">
              {t('auth.forgot_email', 'Forgot Email?')}
            </Link>
          </div>
        </form>

        {message && <p className="text-center mt-6 text-sm font-medium text-brand-primary bg-brand-primary/5 p-4 rounded-xl">{message}</p>}
      </div>
    </>
  );
};

export default Login;




// import React, { useState } from "react";
// import axios from "axios";
// import { Helmet } from "react-helmet-async";
// import { setToken, setUser } from "../utils/auth";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import CONFIG from "../config";
// import BRANDING from "../branding";


// const Login = () => {
//   const { t, i18n } = useTranslation();
//   const isArabic = i18n.language?.startsWith('ar');
//   const [formData, setFormData] = useState({ email: "", password: "" });
//   const [message, setMessage] = useState("");
//   const navigate = useNavigate();

//   const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

//   const handleDemoLogin = async () => {
//     const demoCredentials = { email: "admin@demo.com", password: "adminpassword123" };
//     setFormData(demoCredentials);
//     setMessage(isArabic ? "جاري تسجيل الدخول للنسخة التجريبية..." : "Logging in to demo account...");

//     try {
//       const res = await axios.post(`${CONFIG.API_URL}/api/auth/login`, demoCredentials, { withCredentials: true });
//       setToken(res.data.token);
//       if (res.data.user) setUser(res.data.user);
//       setMessage(`✅ ${t('auth.success_login')}`);
//       setTimeout(() => navigate("/shop"), 500);
//     } catch (error) {
//       setMessage(isArabic ? "فشل تسجيل الدخول التجريبي. هل قمت بتشغيل نص البذر؟" : "Demo login failed. Did you run the seed script?");
//     }
//   };

//   const handleSubmit = async (e) => {
//     if (e) e.preventDefault();
//     setMessage(t('auth.logging_in'));
//     try {
//       const res = await axios.post(`${CONFIG.API_URL}/api/auth/login`, formData, { withCredentials: true });
//       setToken(res.data.token);
//       if (res.data.user) setUser(res.data.user);

//       setMessage(`✅ ${t('auth.success_login')}`);
//       navigate("/shop");
//     } catch (error) {
//       setMessage(error.response?.data?.message || t('auth.failed_login'));
//     }
//   };

//   return (
//     <>
//       <Helmet>
//         <html lang={isArabic ? "ar" : "en"} dir={isArabic ? "rtl" : "ltr"} />
//         <title>
//           {isArabic
//             ? `تسجيل الدخول | ${BRANDING.appName.ar}`
//             : `Login | ${BRANDING.appName.en}`}
//         </title>
//       </Helmet>

//       <div className="max-w-md mx-auto mt-16 bg-white shadow-lg p-10 rounded-[30px] border border-gray-100">
//         <h2 className="text-3xl font-black mb-8 text-center text-gray-900">{t('auth.login')}</h2>
//         <form onSubmit={handleSubmit} className="space-y-6">
//           <div>
//             <label className="block text-xs font-black uppercase tracking-widest text-gray-400 mb-2">{t('auth.email')}</label>
//             <input
//               type="email"
//               name="email"
//               value={formData.email}
//               placeholder="email@example.com"
//               onChange={handleChange}
//               className="w-full p-4 bg-gray-50 border-none rounded-2xl focus:ring-2 focus:ring-brand-primary/20 transition-all outline-none"
//               required
//             />
//           </div>
//           <div>
//             <label className="block text-xs font-black uppercase tracking-widest text-gray-400 mb-2">{t('auth.password')}</label>
//             <input
//               type="password"
//               name="password"
//               value={formData.password}
//               placeholder="••••••••"
//               onChange={handleChange}
//               className="w-full p-4 bg-gray-50 border-none rounded-2xl focus:ring-2 focus:ring-brand-primary/20 transition-all outline-none"
//               required
//             />
//           </div>
//           <button
//             type="submit"
//             style={{ backgroundColor: BRANDING.colors.primary }}
//             className="w-full text-white py-5 rounded-2xl font-black uppercase tracking-widest hover:brightness-110 active:scale-95 transition-all shadow-xl shadow-brand-primary/20"
//           >
//             {t('auth.login')}
//           </button>
//         </form>

//         {message && <p className="text-center mt-6 text-sm font-medium text-brand-primary bg-brand-primary/5 p-4 rounded-xl">{message}</p>}
//       </div>
//     </>
//   );
// };

// export default Login;
